import find from "lodash/find";
import { useCustomTypes } from "PFCore/helpers/use_custom_types";
import { Activity } from "PFTypes";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useTemplate } from "../../hooks";

export const useCostFieldLabel = (activity: Activity) => {
  const { t } = useTranslation("activities", { keyPrefix: "scenario.assignmentTable" });

  const { economics_config: economicsConfig } = useTemplate(activity.template_id) || {};

  const { customTypes } = useCustomTypes();

  const costFieldLabel =
    find(customTypes, ["name", economicsConfig?.cost_field_name])?.display_as || t("grade");

  return useMemo(() => costFieldLabel, [costFieldLabel]);
};
